import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import type { ScheduleTreeItemType } from './types.ts'
import { useLoadTree } from './api.ts'
import { sortBy } from 'lodash'

export const useSchedulesTree = defineStore('schedules_tree', () => {
  const objects = ref<ScheduleTreeItemType[]>([])

  const contextObject = ref<ScheduleTreeItemType | null>(null)
  const contextPosition = ref({ x: 0, y: 0 })

  /**
   * Функция получения корня дерева с сервера
   */
  const load = () => {
    const res = useLoadTree()

    res.refetch()
    watch(res.data, () => {
      objects.value = build(res.data.value?.data || [])
    })

    return res
  }

  /**
   * Функция получения потомков дерева с сервера
   * @param item
   */
  const loadChild = (item: ScheduleTreeItemType) => {
    const res = useLoadTree(item.id)

    watch(res.data, () => {
      item.children_list = build(res.data.value?.data || [])
    })

    return res
  }

  /**
   * Функция построения дерева
   * @param data
   */
  const build = (data: any[]): ScheduleTreeItemType[] => {
    return sortBy(data, 'name').map((item) => {
      return {
        ...item,
        children_list: [],
      }
    })
  }

  return {
    objects,
    contextObject,
    contextPosition,

    load,
    loadChild,
  }
})
